import React, { useState, useRef, useEffect } from 'react';
import { serverURL } from '../config/urls';
import { logEvent } from '@firebase/analytics';
import {analytics} from '../config/firebase-logging';
import { useCareerContext } from './career-context';

import "../styles/chatbot.css"
function Chatbot() {
    const { handleError } = useCareerContext();

    const [error, setError] = useState("");
    const [inputValue, setInputValue] = useState("");
    const [chat, setChat] = useState([
        { "role": "assistant", "content": "Hello! I'm Sampy. I'm here to help you find a fitting career. Tell me about your hobbies, favorite subjects, and more!" }
    ]);
    const [isPopupShown, setIsPopupShown] = useState(!localStorage.getItem('dontShowChatbot'));
    const [isLoading, setIsLoading] = useState(false);
    const [conversationId, setConversationId] = useState("");
    const chatboxRef = useRef(null);
    const inputRef = useRef(null);

    useEffect(() => {
        scrollToBottom();
    }, [chat]);

    // Scroll to bottom of chatbox to show new message
    function scrollToBottom() {
        chatboxRef.current.scrollTop = chatboxRef.current.scrollHeight;
    }

    function handleDontShow(e) {
        if (e.target.checked) {
            localStorage.setItem('dontShowChatbot', true);
        } else {
            localStorage.removeItem('dontShowChatbot');
        }
    }


    // Dynamically resize height of input box
    function handleInputChange(e) {
        e.target.style.height = 0;
        e.target.style.height = e.target.scrollHeight + "px";
        if (e.target.scrollHeight > 100) {
            e.target.style.overflowY = "auto";
        } else {
            e.target.style.overflowY = "hidden";
        }
        setInputValue(e.target.value);
    }

    function handleKeyDown(e) {
        if (e.key === "Enter") {
            e.preventDefault();
            // Don't send empty message or if sending message
            if (inputValue === "" || isLoading) {
                return
            }
            sendMessage();
        }
    }

    function sendMessage() {
        setIsLoading(true);
        // Add newest question to chat
        const userMessage = inputValue;
        const newChat = [...chat, { "role": "user", "content": userMessage }, { "role": "assistant", "content": "..." }];
        setChat(newChat);

        // Clear input box
        setInputValue("");
        fetch(serverURL + "/career-chatbot",
            {
                headers: { 'Authorization': `Bearer ${localStorage.getItem('token')}`, "Content-Type": "application/json" }, method: "POST", body: JSON.stringify({
                    message: newChat.slice(0, -1),
                    conversationId: conversationId
                })
            })
            .then(response => response.json())
            .then(data => {
                if (!conversationId) {
                    setConversationId(data.conversationId);
                }
                const { error, message } = data;
                const chatWithoutLoader = newChat.slice(0, -1);
                if (error) {
                    setChat(chatWithoutLoader);
                    handleError(message)
                } else {
                    // set chat with response
                    setChat([...chatWithoutLoader, { "role": "assistant", "content": message }]);
                }
                setIsLoading(false);

            })
            .catch(err => {
                handleError("An unknown error occured")
                if (process.env.REACT_APP_ENVIRONMENT === "production") {
                    logEvent(analytics, 'error', { error_message: 'recommendation_chat_failed: ' + err.message })
                }
                setIsLoading(false);
            });
    }
    return (
        <div className='recommended container col' style={{ textAlign: "center" }}>
            {
                isPopupShown && 
                <div className='popup-overlay' onClick={()=>setIsPopupShown(false)}>
                    <div className='popup-content' onClick={(e) => e.stopPropagation()}>
                        <button className='close-button' onClick={() => setIsPopupShown(false)}>×</button>
                        <img alt="chatbot" src={require("../img/chatbot.png")} width="100px" />
                        <div className='row'>
                            <div className='col'>
                                <h2>Meet Sampy, our personalized career finder bot</h2>
                                <p>Sampy helps you narrow your search by recommending careers you're more likely to enjoy. Keep in mind that there are careers you wouldn't expect to like, so don't feel limited by these suggestions!</p>
                            </div>
                        </div>
                        <button className='primary-btn' style={{ padding: "12px 65px", fontSize: "18px" }} onClick={() => setIsPopupShown(false)}>Continue</button>
                        <div className='row' style={{ justifyContent: "center", gap: "5px", marginTop: "10px" }}>
                            <input type="checkbox" onClick={handleDontShow}/>
                            <label>Don't show this again</label>
                        </div>
                    </div>
                </div>
            }

            <div className={`error ${error ? 'show' : ''}`}>{error}</div>
            <div className="chatbox" ref={chatboxRef}>
                {chat.map((message, index) => (
                    (message.role === "user" || message.role === "assistant") && (
                        <div className={"chat-message row " + message.role} key={index} style={{ justifyContent: "space-between", alignItems: "flex-start" }}>
                            <div>
                                {(message.role === "assistant") ? <img alt="chatbot" src={require("../img/chatbot.png")} height="30px" /> : <></>}
                            </div>
                            <div className='message-content'>{message.content}</div>
                        </div>
                    )
                ))}
            </div>
            <div className='chat-input row' style={{ alignItems: "flex-start" }}>
                <textarea placeholder='Type message here (do not share personal data)' ref={inputRef} maxLength={350} value={inputValue} type="text" onChange={handleInputChange} onKeyDown={handleKeyDown} style={{ maxHeight: "200px", overflowY: "hidden", height: "24px" }} />
                <button type="submit" className="send-btn" onClick={sendMessage} ><i className="fa fa-paper-plane" style={{ color: 'gray' }}></i></button>
            </div>


        </div>

    );
}

export default Chatbot;